import { useNavigate } from 'react-router-dom'

import { selectContractorByUuid } from '../../payroll.selectors'
import { ContractorPayrollHeader } from './ContractorPayrollHeader'
import { ContractorPayrollOverview } from './ContractorPayrollOverview'
import { getContractorWages } from '../../helpers'
import { Button, Icon, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
export const ContPayrollConfirmationTab = ({
  contractorUuid,
  hours,
  wage,
  bonus,
  reimbursement,
  payDate,
}: {
  contractorUuid: string
  payDate: string
  hours: string
  wage: string
  bonus: string
  reimbursement: string
}) => {
  const navigate = useNavigate()
  const contractor = useReselector(selectContractorByUuid, contractorUuid)

  if (!contractor) {
    return null
  }

  const { total } = getContractorWages({
    contractor,
    bonus,
    hours,
    wage,
    reimbursement,
  })

  return (
    <div className="flex flex-col gap-6">
      <ContractorPayrollHeader currentTab={3} />

      <Text variant={TypographyStyles.H1}>You&apos;re all set!</Text>

      <Text variant={TypographyStyles.H3}>
        We&apos;ll debit funds on the date listed below to pay your contractors
      </Text>

      <ContractorPayrollOverview payDate={payDate} total={total} />

      <div className="flex flex-wrap gap-4 mt-4">
        <div className="w-full md:w-1/4">
          <Button
            variant="secondary"
            onClick={() => navigate('/payroll/history?tab=contractor')}
          >
            View Payment History
          </Button>
        </div>
        <div className="w-full md:w-1/4">
          <Button onClick={() => navigate('/payroll/run_payroll')}>
            <Icon icon={faArrowLeft} className="mr-2" />
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
